import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { MapData } from 'types/Meteorology/indicesClimaticos';
import { cssVar } from 'constants/theme';

import './index.scss';

export interface FullscreenMapProps {
  map: MapData | null;
  variable: string;
  monthLabel?: string;
  dismiss: () => void;
}

export default function FullscreenMap({
  map,
  variable,
  monthLabel,
  dismiss,
}: FullscreenMapProps) {
  if (!map) return null;

  return (
    <div className="agro-simil-fullscreen-map">
      <div className="agro-simil-fullscreen-map-header">
        <div className="agro-simil-fullscreen-map-titles">
          <span className="agro-simil-fullscreen-map-title">
            {`Anomalia · ${map.ano}`}
          </span>
          <span className="agro-simil-fullscreen-map-subtitle">
            {[variable, monthLabel].filter(Boolean).join(' · ')}
          </span>
        </div>
        <button
          type="button"
          className="agro-simil-fullscreen-map-close"
          aria-label="Fechar mapa em tela cheia"
          onClick={dismiss}
        >
          <Icon iconType="close" color={cssVar('text-on-accent')} size="small" />
        </button>
      </div>

      <div className="agro-simil-fullscreen-map-body">
        <div className="agro-simil-fullscreen-map-frame">
          <img src={map.link} alt={`Mapa de anomalia - ${variable} ${map.ano}`} />
        </div>
      </div>
    </div>
  );
}
